module.exports = __webpack_public_path__ + "static/media/Nov7-17.5706e7bd.png";